import React, { useState } from 'react'
import { IoIosArrowDropdown } from "react-icons/io";

const FaqSection = ({ faqItems }) => {
    const [isActiveIndex, setIsActiveIndex] = useState(null);

    const handleClick = (index) => {
        setIsActiveIndex(index === isActiveIndex ? null : index)
    }
    return (
        <>
            <div className='w-full'>
                <div className='container mx-auto   md:container md:mx-auto my-8 '>
                    {faqItems.map((item, id) => (
                        <div key={id} className='text-white  gap-5 py-3' >
                            <div className='flex items-center gap-3 w-[100%] justify-between '>
                                <p className='md:text-2xl text-xl ' >{item.title}</p>
                                <span onClick={() => handleClick(id)} className={isActiveIndex === id ? " text-white cursor-pointer duration-500 p-2 rounded-full border  border-purple-900 bg-purple-900  " : "rotate-180 p-2 duration-500 rounded-full border border-purple-500 "}>< IoIosArrowDropdown size={25} /></span>
                            </div>
                            {id === isActiveIndex && <p className='text-xl text-gray-300 w-[90%]'>{item.contant}</p>}
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default FaqSection